module.exports = __webpack_public_path__ + "static/media/county_fair.7ab6dd46.png";